module.exports = __webpack_public_path__ + "static/Images-2-fa1189fed82ab185f7be6041f1886b89.png";